// extracted by mini-css-extract-plugin
export default {"alert":"BannerAlert_alert__je0g-"};